/**
 * Date formatting helper.
 *
 * formatDateToLocal converts backend UTC date strings (appending "Z" when no
 * timezone info is present) to a localized date/time string in the browser's
 * locale and timezone, falling back to parsing the raw string and returning
 * "" for unparseable input. Used by the admin list item view.
 */
export function formatDateToLocal(dateString: string): string {
    // The backend sends UTC dates, but they might not have the 'Z' suffix.
    // Only append 'Z' if the string doesn't already have timezone information.
    const hasTimezone = dateString.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(dateString);
    const dateStringWithTimezone = hasTimezone ? dateString : dateString + "Z";
    const date = new Date(dateStringWithTimezone);

    if (isNaN(date.getTime())) {
        console.log("date is invalid", date);
        // If appending 'Z' resulted in an invalid date, it might already have timezone info
        // or be in a different format. Let's try parsing the original string.
        const originalDate = new Date(dateString);
        if (isNaN(originalDate.getTime())) {
            return ""; // Return empty string if date is invalid
        }
        return originalDate.toLocaleString(undefined, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    }

    // Format date and time according to the user's browser locale and timezone
    return date.toLocaleString(undefined, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}
